export default "__VITE_ASSET__BW$xsNj8__"